module.exports = __webpack_public_path__ + "img/m_number-title.27a28855.png";